import { TransformNode } from '@babylonjs/core/Meshes/transformNode';
import { MateNode } from '@models/classes/mates/mate-node';
import { Token } from '@models/classes/token';
import { ITrackedClass } from '@models/interfaces';
import { SyncService } from '@models/services/sync-service';
import { Renderer } from './renderer';

export class MateRenderer extends Renderer<MateNode, TransformNode> {
    modelToken = Token.MateNode;

    update3dInternal(node: ITrackedClass<MateNode>) {}
    delete3d(node: ITrackedClass<MateNode>) {
        SyncService.nodeDeletionProcessed(node);
    }
}
